import { mapGetters } from 'vuex';
import lodash from 'lodash';

export default {
  computed: {
    ...mapGetters({
      insuranceCompanyList: 'forms/insuranceCompany/insuranceCompanyList'
    }),
    hasBenefits() {
      return !lodash.isEmpty(this.currentProviderBenefitsData);
    },
    currentProvider() {
      return this.$auth.user.healthInsuranceCompany
        ? this.insuranceCompanyList.find(val => val.id === this.$auth.user.healthInsuranceCompany)
        : null;
    },
    currentProviderBenefitsData() {
      if (lodash.isEmpty(this.currentProvider)) {
        return [];
      }
      const locale = this.$i18n.locale;
      const items = this.$i18n.getLocaleMessage(locale)?.insuranceBenefits?.items ?? [];
      return items.find(val => val.slug === this.currentProvider.additionalInfo.slug) ?? [];
    }
  }
};
